projectFunctions.customPostGridFunctions = projectFunctions.customPostGridFunctions || {};

/**
 * Init: Will be triggered on document ready.
 */
projectFunctions.customPostGridFunctions.init = function() {
    this.customPostGrid();
};

projectFunctions.customPostGridFunctions.customPostGrid = function () {
    const wrapper = document.querySelector('.post-grid-wrapper');
    if (!wrapper) {
        return;
    }

    const elements = {
        wrapper,
        grid: wrapper.querySelector('.custom-post-grid'),
        spinner: wrapper.querySelector('.spinner-container')
    };

    const state = {
        postType: wrapper.dataset.postType,
        taxonomy: wrapper.dataset.taxonomy,
        page: 1,
        loading: false,
        currentCategory: 'all',
        maxPages: Infinity,
        reset: false
    };

    function loadPosts(state, elements) {
        if (state.loading) return;
        state.loading = true;
        elements.spinner.classList.add('active');
    
        jQuery.ajax({
            type: 'POST',
            url: AjaxMethodsUrl,
            data: {
                action: 'custom_post_grid',
                page: state.page,
                post_type: state.postType,
                taxonomy: state.taxonomy || 'category',
                current_category: state.currentCategory,
            },
            beforeSend: function () {
                // If page loading or filter clicked clear the content before inserting html
                if (state.reset) elements.grid.innerHTML = "";
                elements.spinner.classList.add('active');
            },
            success: function (response) {
                let res = JSON.parse(response);
                elements.grid.insertAdjacentHTML('beforeend', res.html);
                state.maxPages = res.maxPages;
                elements.spinner.classList.remove('active');
            },
            complete: function () {
                elements.spinner.classList.remove('active');
                state.loading = false;
                state.page++;
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.error('Ajax error:', textStatus, errorThrown);
            },
        });
    }
    
    function filterPosts(state, elements) {
        const filters = document.querySelectorAll('.filter-button');
    
        if (!filters) {
            return;
        }
    
        filters.forEach(filter => {
            filter.addEventListener('click', (e) => {
                filters.forEach(f => {
                    f.classList.remove('active')
                });
                filter.classList.add('active');
                state.currentCategory = filter.dataset.category;
                state.page = 1;
                state.reset = true;
                loadPosts(state, elements);
            })
        })
    }
    
    function inifiniteScroll(state, elements) {
        window.addEventListener('scroll', () => {
            const rect = elements.wrapper.getBoundingClientRect();
    
            if (rect.bottom <= window.innerHeight && state.page <= state.maxPages) {
                state.reset = false;
                loadPosts(state, elements);
            }
        });
    }
}